export const data=[
    {
        imgSrc:require('../../../assets/pyramidSimple.png'),
        code:`import { PopulationPyramid } from "react-native-gifted-charts";
        
const App = () => {
    const data = [
        {left: 15, right: 17},
        {left: 30, right: 27},
        {left: 26, right: 25},
        {left: 40, right: 44}
    ];
    return <PopulationPyramid data={data}/>;
};`
    },
    {
        imgSrc:require('../../../assets/pyramidBarLabels.png'),
        code:`import { PopulationPyramid } from "react-native-gifted-charts";
        
const App = () => {
    const data = [
        {left: 15, right: 17},
        {left: 30, right: 27},
        {left: 26, right: 25},
        {left: 40, right: 44}
    ];
    return <PopulationPyramid data={data} showValuesAsBarLabels />;
};`
    },
    {
        imgSrc:require('../../../assets/pyramidAltLabels.png'),
        code:`import { PopulationPyramid } from "react-native-gifted-charts";
        
const App = () => {
    const data = [
        {left: 15, right: 17, leftBarLabel: '~15', rightBarLabel: '~17'},
        {left: 30, right: 27},
        {left: 26, right: 25, leftBarLabel: '26->', rightBarLabel: '<-25'},
        {left: 40, right: 44, leftBarLabel: '40'}
    ];
    return <PopulationPyramid data={data} />;
};`
    },
    {
        imgSrc:require('../../../assets/midAxis.png'),
        code:`import { PopulationPyramid } from "react-native-gifted-charts";
        
const App = () => {
    const data = [
        {left: 15, right: 17},
        {left: 30, right: 27},
        {left: 26, right: 25},
        {left: 40, right: 44}
    ];
    return <PopulationPyramid data={data} showMidAxis />;
};`
    }
]